"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _orderModify = require("@/api/order-modify");
var ModifyHistoryModal = /*#__PURE__*/function (_Vue) {
  function ModifyHistoryModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ModifyHistoryModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ModifyHistoryModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      orderId: null
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(ModifyHistoryModal, _Vue);
  return (0, _createClass2.default)(ModifyHistoryModal, [{
    key: "handleUpdate",
    value: function handleUpdate(row) {
      var order = JSON.parse(row.orderJson);
      var previousOrder = {};
      var findIndex = this.data.findIndex(function (e) {
        return e.id == row.id;
      });
      if (findIndex > -1 && findIndex < this.data.length - 1) {
        previousOrder = JSON.parse(this.data[findIndex + 1].orderJson);
      }
      this.$refs.OrderModal.handleView(order, previousOrder);
    }
    // fetch history modify
  }, {
    key: "fetchHistory",
    value: function () {
      var _fetchHistory = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _orderModify.orderModifyHistoryApi.findAll(this.query);
            case 2:
              res = _context.sent;
              this.data = res.data.orderModifyHistories;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchHistory() {
        return _fetchHistory.apply(this, arguments);
      }
      return fetchHistory;
    }()
  }, {
    key: "handleView",
    value: function handleView(data) {
      this.query.orderId = data.id;
      this.fetchHistory();
      this.visible = true;
    }
  }]);
}(_vuePropertyDecorator.Vue);
ModifyHistoryModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    OrderModal: function OrderModal() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("./OrderModal.vue"));
      });
    }
  }
})], ModifyHistoryModal);
var _default = exports.default = ModifyHistoryModal;